var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"font-medium",on:{"mouseover":_vm.handleMouseOver,"mouseout":_vm.handleMouseOut}},[_c('mp-link',{staticClass:"font-normal uppercase transition-colors cursor-pointer hover:text-brandRed tracking-wider",attrs:{"to":_vm.$u(_vm.menuItem.link)}},[_vm._v("\n    "+_vm._s(_vm.menuItem.label)+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }